import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { SearchSocketJob } from '../apis/core-search-api-service.interface';

export const GetSocketPath = Symbol('GetSocketPath');

export interface GetSocketPath {
    getSocketPath: (options: { socketType: string; }) => Promise<string>;
}

@injectable()
export class GetSocketPathImpl implements GetSocketPath {
    constructor(
        @inject(SearchSocketJob)
        private readonly _searchSocketJob: SearchSocketJob,
    ) {}

    async getSocketPath(options: { socketType: string; }) {
        const data = await this._searchSocketJob.searchSocketJob({
            socket_type: options.socketType,
        });
        const { job_id, sock_path } = data;
        const path = sock_path.replace('*', job_id);
        return `${process.env.VUE_APP_ANALYTICS_SOCKET_URI}/core-search-api/search${path}`;
    }
}
